var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeech(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.67 98.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e3e80;}.cls-2{fill:#59ac31;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.22,91.96c-.66,0-1.26-.43-1.45-1.1-.23-.8,.24-1.64,1.04-1.86,18.75-5.31,31.85-22.65,31.85-42.16,0-24.16-19.66-43.82-43.82-43.82S3.02,22.68,3.02,46.84c0,19.15,12.79,36.4,31.1,41.94,.8,.24,1.25,1.08,1.01,1.88-.24,.8-1.07,1.26-1.88,1.01C13.67,85.74,0,67.31,0,46.84,0,21.01,21.01,0,46.84,0s46.84,21.01,46.84,46.84c0,20.86-14,39.39-34.05,45.07-.14,.04-.28,.06-.41,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.84,50.69c-.72,0-1.3-.58-1.3-1.3V21c0-.72,.58-1.3,1.3-1.3s1.3,.58,1.3,1.3v28.39c0,.72-.58,1.3-1.3,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.96,36.29c-.62,0-1.2-.38-1.42-.99-.29-.78,.12-1.65,.9-1.93l12.47-4.54c.79-.29,1.65,.12,1.93,.9,.29,.78-.12,1.65-.9,1.93l-12.47,4.54c-.17,.06-.35,.09-.52,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.14,94.25c0,2.37-1.92,4.29-4.29,4.29s-4.29-1.92-4.29-4.29,1.92-4.29,4.29-4.29,4.29,1.92,4.29,4.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.77,36.29c-.17,0-.35-.03-.52-.09l-12.47-4.54c-.78-.28-1.19-1.15-.9-1.93,.28-.78,1.15-1.19,1.93-.9l12.47,4.54c.78,.28,1.19,1.15,.9,1.93-.22,.61-.8,.99-1.42,.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.85,87.2c-1.33,0-2.42-1.08-2.42-2.42v-3.06c0-2.45,2.36-4.13,4.44-5.61,.41-.29,.8-.57,1.14-.83,2.25-1.86,3.88-3.39,3.88-5.79,0-3.89-3.17-7.06-7.06-7.06s-7.06,3.17-7.06,7.06c0,1.33-1.08,2.42-2.42,2.42s-2.42-1.08-2.42-2.42c0-6.56,5.34-11.89,11.9-11.89s11.89,5.34,11.89,11.89c0,4.87-3.43,7.7-5.69,9.56-.44,.35-.89,.67-1.36,1-.72,.51-2.01,1.43-2.4,1.95v2.78c0,1.33-1.08,2.42-2.42,2.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.22,46.53c0,2.24-1.81,4.05-4.05,4.05s-4.05-1.81-4.05-4.05,1.81-4.05,4.05-4.05,4.05,1.81,4.05,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.46,46.53c0,2.24,1.81,4.05,4.05,4.05s4.05-1.81,4.05-4.05-1.81-4.05-4.05-4.05-4.05,1.81-4.05,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.96,36.29c-.62,0-1.2-.38-1.42-.99-.29-.78,.12-1.65,.9-1.93l12.47-4.54c.79-.29,1.65,.12,1.93,.9,.29,.78-.12,1.65-.9,1.93l-12.47,4.54c-.17,.06-.35,.09-.52,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.77,36.29c-.17,0-.35-.03-.52-.09l-12.47-4.54c-.78-.28-1.19-1.15-.9-1.93,.28-.78,1.15-1.19,1.93-.9l12.47,4.54c.78,.28,1.19,1.15,.9,1.93-.22,.61-.8,.99-1.42,.99Z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeech);
export default __webpack_public_path__ + "static/media/Speech.d77c5397479223f0a5175e8ae3444b44.svg";
export { ForwardRef as ReactComponent };